import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NotificationDialog = ({ open, handleClose }) => {
  return (
    <Dialog fullScreen open={open} handleClose={handleClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1, textAlign: 'center' }} variant="h6" component="div">
            Notifikasi
          </Typography>
        </Toolbar>
      </AppBar>
      <List>
      <ListItemText primary="Terbaru"/>
        {/* <ListItemButton>
          <ListItemText primary="Service" secondary="Gadget" />
        </ListItemButton>
        <Divider />
        <ListItemButton>
          <ListItemText primary="Service" secondary="Tablet" />
        </ListItemButton> */}
      </List>
    </Dialog>
  );
};

export default NotificationDialog;
